// API
// ----------------------------------------------------------------------

export const GOOGLE_MAP_API = process.env.REACT_APP_MAP_API;

// LAYOUT
// ----------------------------------------------------------------------

export const NAV = {
  W_BASE: 380,
  W_DRAWER: 380,
  //
  H_ITEM: 48,
  H_ITEM_SUB: 36,
};

export const ICON = {
  NAV_ITEM: 24,
};

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
};
